import { useEffect } from "react";

export function useTitle(title) {
  useEffect(() => {
    const prevTitle = document.title;
    const prefix = "Bookit | ";
    document.title = prefix + title;
    return () => {
      document.title = prevTitle;
    };
  }, []);
}
